export default __webpack_public_path__ + "static/media/ondo_State_Logo.0bc17fda.png";